import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b4e8626"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProductPageConfig" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ProductPageConfig-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal(_ctx.modalName)))
    }, [
      _createVNode(_component_InlineSVG, {
        src: require('@a/icons/settings.svg')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_Modal, {
      visible: _ctx.currentModal === _ctx.modalName,
      onModalCancel: _ctx.cancelModal
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_CustomSelect, {
            class: "ProductPageConfig-contextCodeSelect ProductPageConfig-modalField",
            label: "CountryCode",
            modelValue: _ctx.countryCodeRef,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.countryCodeRef) = $event)),
            items: _ctx.countryCodeList
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_CustomSelect, {
            class: "ProductPageConfig-localeSelect ProductPageConfig-modalField",
            label: "Language",
            modelValue: _ctx.langRef,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.langRef) = $event)),
            items: _ctx.langList
          }, null, 8, ["modelValue", "items"])
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_CustomButton, { onClick: _ctx.cancelModal }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_CustomButton, {
          onClick: _ctx.validateModal,
          type: "light"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible", "onModalCancel"])
  ]))
}